





















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { ContentPriceSubjectTypeEnum } from "@scrile/api-provider/dist/api/ContentPriceProvider";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { PaymentPackage, PaymentPackageEnum } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import { formatMoneyString } from "@/lib/moneyHelpers";
import { format, parse } from "@/lib/time";
import { FormFields, FormValues, PostFileData } from "@/types";
import BaseForm from "@/components/BaseForm";
import EditPostDropZone from "../EditPostDropZone";
import PostFilesArea from "../PostFilesArea";

@Component({
  name: "EventPostEditView",
  components: { BaseForm, PostFilesArea, EditPostDropZone },
})
export default class EventPostEditView extends Vue {
  @Prop({ required: true })
  public readonly postData!: ContentSet;

  @Prop({ required: true })
  public readonly fileList!: PostFileData[];

  public priceList: SubscriptionLevel[] = [];

  public packageList: PaymentPackage[] = [];

  public pricePackageId = "0";

  public levelId = "0";

  public values: FormValues = {};

  public get isFree() {
    return this.values.levelId === "0" && this.values.pricePackageId === "0";
  }

  public get fields(): FormFields {
    const packageOptions = [{ text: $t("Disable one-time purchase"), value: "0" }].concat(
      this.packageList.map(packageData => ({
        text: formatMoneyString(packageData.amount),
        value: packageData.id,
      }))
    );

    return [
      {
        name: "date",
        label: $t("Date"),
        type: "date",
        rules: ["required"],
        disabled: this.postData.published,
        validationMode: "aggressive",
      },
      {
        name: "time",
        label: $t("Time"),
        type: "time",
        rules: ["required"],
        disabled: this.postData.published,
        validationMode: "aggressive",
      },
      {
        name: "duration",
        label: $t("Duration"),
        type: "select",
        rules: ["required"],
        disabled: this.postData.published,
        validationMode: "aggressive",
        options: [
          { text: "15 min", value: 15 },
          { text: "30 min", value: 30 },
          { text: "60 min", value: 60 },
          { text: "90 min", value: 90 },
          { text: "120 min", value: 120 },
        ],
      },
      {
        name: "pricePackageId",
        label: $t("Ticket price"),
        type: "select",
        rules: ["required"],
        disabled: this.postData.published,
        validationMode: "aggressive",
        options: packageOptions,
      },
    ];
  }

  public async sendEventData() {
    if (this.postData.published) return;
    providers.EventPostProvider.setReceiveErrors(false);
    await providers.EventPostProvider.update({
      data: {
        postId: this.postData.id,
        time: parse(`${this.values.date} ${this.values.time}`, "yyyy-MM-dd HH:mm", new Date()).toISOString(),
        duration: this.values.duration,
      },
    });
    await Promise.all([
      providers.ContentPriceProvider.update({
        data: {
          subject: {
            subjectId: this.postData.id,
            subjectType: ContentPriceSubjectTypeEnum.EVENT,
          },
          packageId: this.values.pricePackageId,
        },
      }),
      providers.ContentSubscriptionLevelProvider.update({
        data: {
          subject: {
            subjectId: this.postData.id,
            subjectType: ContentPriceSubjectTypeEnum.CONTENT_SET,
          },
          levelId: this.values.levelId,
        },
      }),
    ]);
  }

  public async getData() {
    this.priceList = await providers.SubscriptionLevelProvider.find({ userIds: [this.postData.userId] });
    this.packageList = await providers.PaymentPackageProvider.findAll({ type: [PaymentPackageEnum.FILESET] });
    const data = await providers.EventPostProvider.find({ postIds: [this.postData.id] });
    const event = data.find(i => i.postId === this.postData.id);
    if (!event) return;
    this.$set(this.values, "date", format(new Date(event.time), "yyyy-MM-dd"));
    this.$set(this.values, "time", format(new Date(event.time), "HH:mm"));
    this.$set(this.values, "duration", event.duration);
    this.$set(this.values, "levelId", event.minimumLevelId);
    this.$set(this.values, "pricePackageId", event.ticketPricePackageId);
  }

  public created() {
    this.values = {
      date: format(new Date(), "yyyy-MM-dd"),
      time: format(new Date(), "HH:mm"),
      duration: 15,
      levelId: this.levelId,
      pricePackageId: this.pricePackageId,
    };
    this.getData();
    this.$emit("setUpdateCb", () => this.sendEventData());
  }
}
